import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { Site } from 'shared/hooks';
import { sharedFlexPoolService } from 'api/services';
import { FlexPool } from '../../../../../../services/flex-pool-service.types';

export const useGetFlexPoolsForFlexWorker = (site: Site, flexWorkerId: string = '') => {
  const queryFn = async () =>
    await sharedFlexPoolService.getFlexPoolsForFlexWorker(site, flexWorkerId);
  const options = {
    enabled: flexWorkerId.length > 0,
  };

  return useQuery<Promise<FlexPool[]>, Error, FlexPool[]>(
    QUERY_KEYS.flexPoolsForFlexWorker(flexWorkerId),
    queryFn,
    options
  );
};
